/** Group dispatch events so jobs without a job type still appear on the board. */

export type ServiceBoardQueueLike = {
  id: string;
  label: string;
};

export type ServiceBoardEventLike = {
  queue_id: string | null;
};

export type ServiceBoardQueueSection<T extends ServiceBoardEventLike> = {
  key: string;
  title: string;
  events: T[];
};

export function groupServiceBoardEvents<T extends ServiceBoardEventLike>(
  queues: readonly ServiceBoardQueueLike[],
  events: readonly T[]
): ServiceBoardQueueSection<T>[] {
  const byQueue = new Map<string, T[]>();
  const unassigned: T[] = [];
  for (const event of events) {
    const id = event.queue_id;
    if (!id) {
      unassigned.push(event);
      continue;
    }
    const list = byQueue.get(id) ?? [];
    list.push(event);
    byQueue.set(id, list);
  }

  const sections: ServiceBoardQueueSection<T>[] = [];
  if (unassigned.length > 0) {
    sections.push({ key: "unassigned", title: "No job type", events: unassigned });
  }
  const seen = new Set<string>();
  for (const queue of queues) {
    seen.add(queue.id);
    const rows = byQueue.get(queue.id);
    if (!rows?.length) continue;
    sections.push({ key: queue.id, title: queue.label, events: rows });
  }
  for (const [id, rows] of byQueue) {
    if (seen.has(id) || rows.length === 0) continue;
    sections.push({ key: id, title: "Other", events: rows });
  }
  return sections;
}
